function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { makeStyles } from '@material-ui/core/styles';
import colors from "../../foundations/colors.module.scss";
import typography from "../../foundations/typography.module.scss";
export const standardColor = colors.dark700;
export const disabledColor = colors.dark300;
export const focusedColor = colors.purple800;
export const inlineSelectStandardColor = colors.dark900;
export const inlineSelectPrimaryColor = colors.purple800;
export const inlineSelectErrorColor = colors.red950;
export const inlineSelectDisabledColor = colors.dark500;
export const baseFont = {
  fontFamily: typography.fontFamilyNormal,
  fontSize: typography.fontSizeP1
};
export const useInlineSelectDatePickerStyles = makeStyles({
  root: {
    width: undefined,
    marginRight: '-20px',
    display: 'inline-block',
    position: 'relative',
    paddingRight: '8px'
  },
  helperText: {
    fontSize: 12,
    marginTop: 0,
    marginLeft: 0,
    marginRight: 0,
    '&.positionFixed': {
      position: 'absolute',
      bottom: 0,
      left: 0,
      transform: 'translateY(100%)'
    },
    width: '100%',
    lineHeight: 'normal'
  },
  label: {
    fontFamily: typography.fontFamilyLight,
    color: standardColor,
    fontSize: typography.fontSizeP1,
    '&.Mui-disabled': {
      color: disabledColor
    },
    '&.Mui-focused': {
      color: focusedColor
    }
  },
  input: _ref => {
    let {
      inlineSelectColor
    } = _ref;
    return _objectSpread(_objectSpread({}, baseFont), {}, {
      color: inlineSelectColor,
      '&.Mui-error': {
        color: inlineSelectErrorColor,
        '& .MuiInputAdornment-root svg path[fill="#6942F8"]': {
          fill: "".concat(inlineSelectErrorColor, " !important")
        },
        '& .MuiInputAdornment-root svg path[fill="#C3B3FC"]': {
          fill: "".concat(inlineSelectErrorColor, " !important"),
          opacity: 0.5
        }
      },
      '&.Mui-disabled': {
        color: inlineSelectDisabledColor,
        '& .MuiInputAdornment-root svg': {
          opacity: 0.4
        }
      },
      '& .MuiInputAdornment-root': {
        marginLeft: '-36px',
        marginTop: '-2px',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .MuiIconButton-root': {
          padding: '4px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        '& svg': {
          width: '16px',
          height: '16px',
          display: 'block',
          '& path[fill="#6942F8"]': {
            fill: "".concat(inlineSelectColor, " !important")
          },
          '& path[fill="#C3B3FC"]': {
            fill: "".concat(inlineSelectColor, " !important"),
            opacity: 0.5
          }
        }
      },
      '&.MuiInput-underline': {
        '&&&:before': {
          border: 'none',
          right: 'auto',
          left: 0,
          width: 'calc(100% - 36px)',
          bottom: '4px'
        },
        '&&&:hover:before': {
          borderBottom: '1px solid',
          borderBottomColor: inlineSelectColor,
          bottom: '4px',
          right: 'auto',
          left: 0,
          width: 'calc(100% - 36px)'
        },
        '&&&.Mui-error:hover:before': {
          borderBottom: '1px solid',
          borderBottomColor: inlineSelectErrorColor,
          bottom: '4px',
          right: 'auto',
          left: 0,
          width: 'calc(100% - 36px)'
        },
        '&&:after': {
          border: 'none',
          right: 'auto',
          left: 0,
          width: 'calc(100% - 36px)',
          bottom: '4px'
        }
      }
    });
  },
  inputInput: _ref2 => {
    let {
      isDisabled
    } = _ref2;
    return _objectSpread(_objectSpread({}, baseFont), {}, {
      padding: 0,
      lineHeight: '24px',
      height: 22,
      cursor: isDisabled ? 'default' : 'pointer'
    });
  },
  inputInput_medium: {
    height: 38
  },
  inputInput_small: {
    height: 32
  },
  adornedEnd: {
    paddingRight: 0
  }
});